export enum CompanyTypes {
  INTERNAL = 'INTERNAL',
  SUBSCRIBING = 'SUBSCRIBING',
}
